module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Bold.woff?v=5d4a7b0f2c03d8dd424d45eb4f9673d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Bold.woff
// module id = 643
// module chunks = 0